<template>
    <a v-bind="$attrs" :href="target" class="no-style-link">
        <slot></slot>
    </a>
</template>

<script>
    export default {
        name: 'FolderButtonLink',
        props: {
            target: String,
        }
    };
</script>

<style scoped>
    .no-style-link {
        text-decoration: none;
    }
</style>
